export const kicadImporterConfig = {
  shapeBoundingBoxOuterMargin: 1,
};
